import React from 'react'
import {Typography, Divider, Row, Col, Tag, Card, Space} from 'antd'
import {resolve} from '@q4us-sw/q4us-ui/lib/Cell'

export const Header = ({data,fetchConfig})=>{

    const {
        name,status,short_name,registered_address,registered_country,id,
        np_title_primary,
        np_primary,
        np_position_primary,
        np_phone_primary,
        np_email_primary,
        np_title_secondary,
        np_secondary,
        np_position_secondary,
        np_phone_secondary,
        np_email_secondary,
    } = data;

    const [configs, setConfigs] = React.useState([])

    const load = async ()=>{
        const data = await fetchConfig() || [];
        const cfg = data.reduce((acc,{name, ...args})=>{
            return {...acc, [name]: {name,...args}}
        },{})
        setConfigs(cfg)
    }
    React.useEffect(()=>{
        load();
    },[])

    return <React.Fragment>
        <div className="banner">

            <Typography.Title level={3}>{name}</Typography.Title>
            <Typography.Title level={3} style={{position:"absolute", left: 15,top:15,margin:0}}>{`${`${id}`.padStart(6,'0')}`}</Typography.Title>
            <Tag style={{position:"absolute", right: 15,top:15,padding: 5}}><Typography.Title level={3} style={{margin: 0}}>{status}</Typography.Title></Tag>
            <Row style={{width:'100%'}}>
                <Col style={{padding: 5,textAlign:'left'}} xs={8}>
                    <Space direction={"vertical"} size={0}>
                        <Typography.Text>{np_position_primary}</Typography.Text>
                        <Typography.Text>{`${np_title_primary || ""} ${np_primary||""}`}</Typography.Text>
                        <Typography.Link href={`mailto:${np_email_primary}`}>{np_email_primary}</Typography.Link>
                        <Typography.Link href={`tel:${np_phone_primary}`}>{np_phone_primary}</Typography.Link>
                    </Space>
                </Col>
                <Col xs={8}>
                    <Space direction={"vertical"} size={0}>
                        <Typography.Text>{short_name}</Typography.Text>
                        <Typography.Text>{registered_address}</Typography.Text>
                        <Typography.Text>{resolve({...(configs["registered_country"] || {}), value: registered_country})}</Typography.Text>
                    </Space>
                </Col>
                <Col style={{padding:5}} xs={8}>
                    <Space direction={"vertical"}>
                        <Typography.Text>{np_position_secondary}</Typography.Text>
                        <Typography.Text>{`${np_title_secondary || ""} ${np_secondary || ""}`}</Typography.Text>
                        <Typography.Link href={`mailto:${np_email_secondary}`}>{np_email_secondary}</Typography.Link>
                        <Typography.Text>{np_phone_secondary}</Typography.Text>
                    </Space>
                </Col>
            </Row>
        </div>
    </React.Fragment>
}

export const SectionTitle = ({name})=>{
    return <React.Fragment>
            <div className="section-title">
                <Typography.Title level={3}>{name}</Typography.Title>
            </div>
        <Divider style={{marginTop:0}}/>
    </React.Fragment>
}
